import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Hexagon, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function DashboardShell({ title, tabs, active, onTab, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen nova-aurora">
      <header className="glass-strong border-b border-white/10 sticky top-0 z-40">
        <div className="max-w-[1500px] mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="grid place-items-center w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500"><Hexagon className="w-4 h-4 text-white" strokeWidth={2.4} /></span>
            <div className="font-display font-bold text-white">Nova <span className="text-slate-400 font-normal text-sm">/ {title}</span></div>
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-400 hidden sm:block">{user?.name} · <span className="capitalize">{user?.role}</span></span>
            <Button data-testid="dash-logout" variant="outline" size="sm" className="border-white/15 bg-transparent text-white hover:bg-white/10" onClick={async () => { await logout(); navigate("/"); }}><LogOut className="w-4 h-4 mr-1.5" />Logout</Button>
          </div>
        </div>
      </header>
      <div className="max-w-[1500px] mx-auto px-4 sm:px-6 py-6">
        {tabs && (
          <div className="flex gap-1.5 overflow-x-auto pb-3 mb-6 border-b border-white/10">
            {tabs.map((t) => (
              <button key={t.k} data-testid={`tab-${t.k}`} onClick={() => onTab(t.k)}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${active === t.k ? "bg-violet-600 text-white" : "text-slate-300 hover:bg-white/5"}`}>{t.label}</button>
            ))}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
